function amountFormatter(data: any) {
  if (data === undefined) {
    return 0;
  }

  return data.toString().replace(/\B(?=(?:(\d{2})+(\d)(?!\d))+(?!\d))/g, ",");
}

export { amountFormatter };
